import { useEffect } from 'react';
import Button from '../bootstrap/Button';
import Card, { CardBody } from '../bootstrap/Card';
import Icon from '../icon/Icon';
import { Modal } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

export default function StatusPopup({
	icon,
	color,
	setOpen,
	title,
	label,
	setParentIsHidden = () => { },
	children
}) {
	useEffect(() => {
		!!setParentIsHidden && setParentIsHidden(true);
	}, []);

	return (
		<Modal show={true} onHide={() => { }} isCentered fullscreen={isMobile} >
			<Modal.Header
				onHide={() => {
					setOpen(false);
					!!setParentIsHidden && setParentIsHidden(false);
				}}></Modal.Header>
			<Modal.Body>
				<Card shadow={'none'}>
					<CardBody>
						<div className='row g-4 text-center'>
							{/* <div className='col-12'> */}
							<Icon icon={icon} size='7x' color={color} />
							{/* </div> */}
							{/* <div className='col-12'> */}
							<h2>{title}</h2>
							{/* </div> */}
							{/* <div className='col-12'> */}
							<p>{label}</p>
							{/* </div> */}
							{/* <div className='col-12'> */}
							{children}
							<Button
								color={color}
								isLight
								className='w-100 py-3 text-uppercase'
								size='lg'
								onClick={() => {
									!!setParentIsHidden && setParentIsHidden(false);
									setOpen(false);
								}}>
								Ok
							</Button>
							{/* </div> */}
						</div>
					</CardBody>
				</Card>
			</Modal.Body>
		</Modal>
	);
}
